<template>
  <v-container fluid class="py-0">
    <patient-header />

    <div v-if="paramsToShow && paramsToShow.length" class="d-flex mb-4 flex-wrap" style="gap:8px;">
      <v-card v-for="(param, index) in paramsToShow" :key="index" class="d-flex ma-0 pa-0 flex-grow-1" style="flex-basis:250px;">
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title class="headline">{{ param.name }}</v-list-item-title>
            <v-list-item-subtitle v-if="param.name === 'Индекс SCORE' && getLastValue(196) !== null && getLastValue(196) !== undefined">{{ getLastValue(196) }} <span class="grey--text">(среднее {{ param.final_mean.toFixed(2) }})</span></v-list-item-subtitle>
            <v-list-item-subtitle v-else>{{ param.final_mean.toFixed(2) }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </div>

    <v-row class="mb-2">
      <v-col v-if="showHealthGroup" cols="12" sm="3">
        <health-group />
      </v-col>

      <v-col>
        <div class="d-flex mb-4 flex-wrap" style="gap:16px;">
          <modal depressed icon="add" title="Добавить диагноз" name="Диагноз" component="add-diseases"></modal>
          <modal depressed icon="add" title="Добавить лекарство" name="Лекарство" component="add-medicine"></modal>
          <modal
            depressed
            icon="add"
            class="ml-4"
            title="Назначить лекарство"
            name="Рецепт"
            component="add-medicine-reciept"
          ></modal>
          <v-btn depressed color="primary" title="Запись на прием" @click="showCalendar">
            <v-icon left>add</v-icon>
            Запись на прием
          </v-btn>
          <v-btn depressed color="primary" title="Добавить документ" @click="addDocument">
            <v-icon left>add</v-icon>
            Документ
          </v-btn>
          <v-btn depressed color="primary" title="QR код" @click="showQrCode">
            QR код
          </v-btn>
        </div>

        <v-dialog v-model="qrCodeDialog" max-width="500px">
          <v-card>
            <v-card-title class="headline">
              QR-коды для авторизации
            </v-card-title>
            <v-card-text>
              <v-progress-linear v-if="qrLoading" indeterminate></v-progress-linear>
              <div v-if="qrCodes.length > 0">
                <v-row justify="center">
                  <v-col v-for="item in qrCodes" :key="item.id" cols="12" class="text-center">
                    <h3 class="mb-3">{{ item.name }}</h3>
                    <canvas :ref="`dialog-qr-${item.id}`" class="qr-canvas-dialog"></canvas>
                    <p class="mt-2 text--secondary">{{ item.description }}</p>
                  </v-col>
                </v-row>
              </div>
              <v-alert v-if="!qrLoading && qrCodes.length === 0" type="info" text>
                Нет доступных QR-кодов
              </v-alert>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="qrCodeDialog = false">Закрыть</v-btn>
              <v-btn text color="primary" @click="printQrCodes">Печать</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>

      <!--<v-col align="center">
        <v-btn
            depressed
            color="primary"
            title="Записать на приём"
            @click="sheet = !sheet">
          <v-icon left>add</v-icon>
          приём
        </v-btn>

        <v-bottom-sheet v-model="sheet">
          <v-sheet class="text-center" height="200px">
            <v-btn
                class="mt-6"
                text
                color="red"
                @click="sheet = !sheet"
            >Закрыть
            </v-btn>
            <div class="py-3">This is a bottom sheet using the controlled by v-model instead of
              activator
            </div>
          </v-sheet>
        </v-bottom-sheet>
      </v-col>-->
    </v-row>

    <v-card class="mb-2">
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="3">
            <input-save
              label="Количество сигарет в день"
              field="field_24"
              :param="12"
              :measure="13"
              :last-value="getLastValue(12)"
              hide-details
              class="ma-0 pa-0"
            />
          </v-col>

          <v-col>
            <input-save
              hide-details
              class="ma-0 pa-0"
              label="Слабый алкоголь мл/день"
              field="field_24"
              :param="13"
              :measure="11"
              :last-value="getLastValue(13)"
            />
          </v-col>

          <v-col>
            <input-save
              hide-details
              class="ma-0 pa-0"
              label="Крепкий алкоголь мл/день"
              field="field_24"
              :param="14"
              :measure="11"
              :last-value="getLastValue(14)"
            />
          </v-col>

          <v-col align="center">
            <input-save
              hide-details
              class="ma-0 pa-0"
              label="Спорт часов/день"
              field="field_24"
              :param="15"
              :measure="14"
              :last-value="getLastValue(15)"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <diseases />
    <AllergyList></AllergyList>
    <inspections />
    <agenda />
    <Parameters hide-patient></Parameters>
    <AnalyzDocumentList></AnalyzDocumentList>
    <reciepts />
    <Drugs hide-patient></Drugs>
    <calendar />
    <!-- <metric-report v-if="$config.VUE_APP_SHOW_ALL_METRICS_IKP" />
    <IkpMedParamsExcessMeasurement
      :show-med-params-average-measurement-chart="$config.SHOULD_SHOW_MED_PARAMS_AVERAGE_MEASUREMENT_CHART"
      :show-med-params-excess-measurement-chart="$config.SHOULD_SHOW_MED_PARAMS_EXCESS_MEASUREMENT_CHART"
    /> -->
    <LogEvents></LogEvents>
  </v-container>
</template>

<script>
import PatientHeader from "@/components/PatientHeader";
import Modal from "@/components/Modal";
import Diseases from "@/views/pages/diseases/components/Diseases";
import AllergyList from "@/views/pages/allergy/components/AllergyList";
import Drugs from "@/views/pages/drugs/Drugs";
import Parameters from "@/views/pages/parameters/Parameters";
import MetricReport from "./components/MetricReport";
import LogEvents from "./components/LogEvents";
import Inspections from "./components/Inspections";
import Agenda from "./components/Agenda";
import Calendar from "./components/Calendar";
import Reciepts from "./components/Reciepts";
import InputSave from "@/components/forms/InputSave";
import SelectSave from "@/components/forms/SelectSave";
import HealthGroup from "./components/HealthGroup";
import IkpMedParamsExcessMeasurement from "@/views/pages/ikp/components/IkpMedParamsExcessMeasurement.vue";
import AddDocument from "@/modules/documents/add-document/AddDocument.vue";
import AnalyzDocumentList from "@/views/pages/laboratory-research/components/AnalyzDocumentList.vue";
import { CustomerService } from "@/services/api/customer.service.js";
import { FLAGS } from "@/configs";
import QRCode from "qrcode";
import { getQrCodes } from "@/views/pages/qr-codes/qr-codes.services.js";
import { nextTick } from "vue";

export default {
  name: "IKP",

  components: {
    IkpMedParamsExcessMeasurement,
    HealthGroup,
    SelectSave,
    InputSave,
    Modal,
    Calendar,
    Reciepts,
    Agenda,
    Inspections,
    MetricReport,
    Diseases,
    AllergyList,
    PatientHeader,
    Drugs,
    Parameters,
    AnalyzDocumentList,
    LogEvents,
  },

  data: () => ({
    dialog: false,
    date: "",
    sheet: "",
    menu: "",
    paramsToShow: [],
    qrCodeDialog: false,
    qrCodes: [],
    qrLoading: false,
    latestParams: [],
  }),
  computed: {
    showHealthGroup() {
      const hgFlag = this.$featureFlags.feature(FLAGS.HIDE_IKP_HEALTH_GROUP);
      return hgFlag._value !== "1";
    },
    customerId() {
      return this.$store.state.customer.id;
    },
  },
  async created() {
    await this.loadParamsToShow();
    await this.loadLatestParams();
    this.bindScoreSocket();
  },
  destroyed() {
    this.$echo.private(`customer.${this.customerId}`).stopListening(".score.recalculated");
  },

  methods: {
    async loadParamsToShow() {
      const needed = ["ИМТ", "Индекс SCORE"];
      this.paramsToShow = [];
      const response = await this.$http.get(`v1/customers/${this.customerId}/all-metrics-report`, {
        params: {
          measurements_count: 5,
          language: "ru",
        },
      });
      response.data.data.forEach(element => {
        if (needed.includes(element.name)) {
          this.paramsToShow.push(element);
        }
      });
    },
    bindScoreSocket() {
      this.$echo.private(`customer.${this.customerId}`).listen(".score.recalculated", () => {
        this.loadParamsToShow();
        this.loadLatestParams();
      });
    },
    async loadLatestParams() {
      try {
        const paramIds = [12, 13, 14, 15, 196];
        this.latestParams = await CustomerService.getLatestParameters(this.customerId, paramIds);
      } catch (e) {
        console.error("Ошибка загрузки последних параметров", e);
        this.latestParams = [];
      }
    },
    getLastValue(paramId) {
      const param = this.latestParams.find(p => p.id === paramId);
      return param ? param.lval : null;
    },
    addDocument() {
      this.$dialog.showAndWait(AddDocument, { width: "600px", persistent: true });
    },
    showCalendar() {
      const calendar = document.querySelector("#calendar");
      if (calendar) {
        calendar.scrollIntoView({ behaviour: "smooth", block: "center" });
      }
    },
    async showQrCode() {
      this.qrCodeDialog = true;
      this.qrLoading = true;
      this.qrCodes = [];
      try {
        const codes = await getQrCodes(this.customerId);
        this.qrCodes = codes.length > 0 ? codes : [];
      } catch (error) {
        console.error("Ошибка загрузки QR-кодов =>", error);
        this.qrCodes = [];
      }
      await this.$nextTick();
      await this.renderQrCodes();
      this.qrLoading = false;
    },
    renderQrCodes() {
      const promises = this.qrCodes.map(item => {
        return new Promise(resolve => {
          const canvasRef = this.$refs[`dialog-qr-${item.id}`];
          if (canvasRef && canvasRef[0] && item.data) {
            QRCode.toCanvas(canvasRef[0], item.data, { width: 250, margin: 2 }, error => {
              if (error) console.error("Ошибка генерации QR-кода =>", error);
              resolve();
            });
          } else {
            resolve();
          }
        });
      });
      return Promise.all(promises);
    },
    printQrCodes() {
      const canvases = this.$refs;
      let contentHtml = "";

      this.qrCodes.forEach(item => {
        const canvasRef = this.$refs[`dialog-qr-${item.id}`];
        if (canvasRef && canvasRef[0]) {
          const imgSrc = canvasRef[0].toDataURL();
          contentHtml += `
            <div style="text-align:center; page-break-inside:avoid; margin-bottom:30px;">
              <h3 style="margin-bottom:10px;">${item.name}</h3>
              <img src="${imgSrc}" width="300" height="300" />
              <p style="margin-top:8px; color:#666;">${item.description}</p>
            </div>
          `;
        }
      });

      const printWindow = window.open("", "_blank");
      nextTick(() => {
        printWindow.document.write(`
        <html>
          <head><title>Печать QR-кодов</title></head>
          <body style="font-family:Arial,sans-serif; padding:40px;">
            ${contentHtml}
          </body>
        </html>
      `);
        printWindow.document.close();
      });
      setTimeout(() => {
        printWindow.print();
      }, 1000);
    },
  },
};
</script>

<style scoped>
.qr-canvas-dialog {
  margin: 0 auto;
  display: block;
}
</style>
